<template>
  <div class="page" ref="page">
    <van-nav-bar :title="train_sign_title" />
    <van-overlay :show="loading" class-name="sava_Overlay" z-index="9999">
      <div class="wrapper">
        <van-loading type="spinner" color="#1989fa" vertical
          >加载中...</van-loading
        >
      </div>
    </van-overlay>
    <div class="login_content">
      <div class="input_box">
        <div class="icon">{{ train_sign_caption }}</div>
        <div class="input_box_xia">
          <van-field
            v-model="sfz"
            placeholder="身份证号码"
            readonly
            clickable
            maxlength="18"
            @touchstart.stop="showKeyboard = true"
          />
          <van-number-keyboard
            :show="showKeyboard"
            v-model="sfz"
            extra-key="X"
            close-button-text="完成"
            @blur="KeyboardBlur"
          />
        </div>
        <div :class="`Sed ${canSubmit ? 'op' : ''}`" @click="check">
          确认
        </div>
      </div>
    </div>
    <!-- 身份证登录时，个人信息确认弹窗 -->
    <van-dialog
      class="PerInfoConfirmDia"
      v-model="showPersonalInfo"
      title="个人信息确认"
      show-cancel-button
      cancel-button-text="返回"
      confirm-button-color="#247dff"
      @confirm="confirmPerDia"
      @cancel="cancelPerDia"
    >
      <van-cell-group inset>
        <van-field v-model="IDCard" label="身份证号码" readonly />
        <van-field v-model="perName" label="姓名" readonly />
        <van-field v-model="perSex" label="性别" readonly />
      </van-cell-group>
    </van-dialog>
    <!-- 确认成功弹窗 -->
    <van-popup v-model="showPop" class="success_pop" position="right">
      <div class="contant">
        <div class="suc_img">
          <img src="@/assets/img/jp.png" alt />
        </div>
        <div class="suc_header" v-html="caption"></div>
        <div class="footer_btn">
          <div class="Sed op" @click="colsePage">
            确定
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Notify, Dialog } from 'vant'
import { IdCodeValid } from '@/utils/index.js'

import {
  getWxApiToken,
  checkTrainSignByIdCardNum,
  postTrainSignConfirm
} from '@/request/api.js'
export default {
  data() {
    return {
      module: this.$route.query.module || '240',
      loading: false,
      showKeyboard: false,
      showPersonalInfo: false, // 身份证登录时，是否弹出个人信息确认弹窗
      showPop: false, // 确认成功弹窗
      isPassing2: false,
      sfz: '',
      IDCard: '',
      perName: '',
      perSex: '',
      mach: false,
      caption: '签到成功！',
      train_sign_title: window.train_sign_title || '身份验证', //培训打卡签到界面顶部标题
      train_sign_caption: window.train_sign_caption || '请输入身份证号码' //培训打卡签到界面标签标题
    }
  },
  created() {
    getWxApiToken().then(res => {
      sessionStorage.setItem('token', res)
    })
  },
  computed: {
    canSubmit() {
      let resu = true
      if (this.sfz.length != 18) {
        resu = false
      }
      return resu
    }
  },
  methods: {
    // 身份证键盘关闭
    KeyboardBlur() {
      // 身份证验证
      if (this.sfz) {
        let sfzTest = IdCodeValid(this.sfz)
        if (sfzTest.pass) {
          this.showKeyboard = false
          this.mach = true
        } else {
          // 否则就是身份证格式错误
          Notify({ type: 'danger', message: sfzTest.msg })
          this.mach = false
        }
      } else {
        this.showKeyboard = false
        this.mach = false
      }
    },
    // 身份确认
    confirmPerDia() {
      this.showPersonalInfo = false
      this.nextOperation(this.result)
    },
    cancelPerDia() {
      this.$router.go(0)
    },
    // 点击确认
    check() {
      if (!this.canSubmit || !this.mach) return
      checkTrainSignByIdCardNum({
        moduleno: this.module,
        idcardnum: this.sfz
      }).then(res => {
        if (res.data.length > 0) {
          if (res.data[0].info) {
            Dialog({ message: res.data[0].info })
          } else {
            this.showPersonalInfo = true
            this.IDCard = res.data[0].idcardnum
            this.perName = res.data[0].empname
            this.perSex = res.data[0].sex
          }
        } else {
          Dialog({ message: '查询失败' })
        }
      })
    },
    // 身份证登录时，身份确认弹窗确认后的操作
    nextOperation(result) {
      this.showPersonalInfo = false
      postTrainSignConfirm({
        moduleno: this.module,
        idcardnum: this.sfz
      }).then(res => {
        if (res.data.length > 0) {
          if (res.data[0].info) {
            Dialog({ message: res.data[0].info })
          } else {
            this.showPop = true
            this.caption = res.data[0].caption.replace(/\\n/g, '<br>')
          }
        } else {
          Dialog({ message: '确认失败' })
        }
      })
    },

    colsePage() {
      this.showPop = false
      window.close()
      WeixinJSBridge.invoke('closeWindow', {}, function(res) {})
    }
  }
}
</script>

<style scoped lang="less">
.PerInfoConfirmDia {
  /deep/.van-dialog__header {
    padding-top: 0;
    height: 110px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    font-weight: 500;
    font-size: 40px;
  }
  .van-dialog__content {
    .van-cell-group {
      padding: 30px;
    }
  }
}
.success_pop {
  width: 80vw;
  left: 10vw;
  height: calc(40vh + 100px);
  background: none;
  padding-top: 10vh;
  .contant {
    width: 80vw;
    height: 30vh;
    background: linear-gradient(180deg, #c2e3ff 0%, #ffffff 100%);
    box-shadow: 0px 3px 6px 0px rgba(82, 155, 178, 0.16);
    border-radius: 14px;
    position: relative;
    .suc_img {
      position: absolute;
      top: -100px;
      width: 100%;
      text-align: center;
      img {
        height: 15vh;
      }
    }
    .suc_header {
      padding-top: 12vh;
      font-size: 48px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #1677ff;
      line-height: 52px;
      text-align: center;
    }

    .wuyong {
      color: #333333;
      font-size: 28px;
      font-weight: bold;
      text-align: center;
      padding: 30px 0;
    }
    .footer_btn {
      width: 100%;
      position: absolute;
      bottom: 40px;
      .Sed {
        width: 70vw;
      }
    }
  }
}
.page {
  height: 100vh;
  overflow-y: scroll;
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }

    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }

    ::v-deep .van-nav-bar__right {
      .van-nav-bar__text {
        color: #ffffff;
        font-family: Source Han Sans CN;
      }
    }
  }
  .sava_Overlay {
    .wrapper {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .loading {
    position: absolute;
    padding-top: 75%;
    padding-left: 45%;
    z-index: 1111;
  }
  .dragVerify {
    padding-top: 32px;
    padding-bottom: 16px;
    display: flex;
    justify-content: center;
    .drag {
      --width: 134px !important;
      --pwidth: -134px !important;
      // background: red!important;
      /deep/.dv_text {
        width: 100%;
        color: red;
      }
    }
    .drag_verify {
      /deep/.dv_handler {
        display: flex;
        justify-content: center;
        align-items: center;
        .fa {
          margin-top: unset;
        }
      }
    }
  }

  .Sed {
    width: 84vw;
    height: 12.533vw;
    margin: 5vw auto;
    background-color: #ededed;

    border-radius: 6.222vw;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.8vw;
    letter-spacing: 0.267vw;
    color: #666666;
  }
  .op {
    background-color: #247dff;
    color: #ffffff;
  }
  .input_box {
    width: 84vw;
    margin: 0 auto;
    margin-top: 13.333vw;
    .icon {
      font-size: 44px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #333333;
      line-height: 30px;
    }
    .input_box_xia {
      min-height: 11.333vw;
      // border-bottom: 1px solid #edeff2;
      border-bottom: 1px solid #70b6ff;
      margin-top: 8vw;
      display: flex;
      justify-content: space-between;
      .code_gain {
        width: 35vw;
        height: 8vw;
        background-color: #edeff2;
        border-radius: 0.5vw;
        font-size: 3.467vw;
        color: #909399;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .code_gain-on {
        background-color: #008eed;
        color: #ffffff;
      }

      /deep/.van-cell {
        border-radius: 0.5vw;
        .van-field__label {
          width: 5.2em;
        }
        .van-field__value {
          .van-field__error-message {
            // position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
